module.exports = __webpack_public_path__ + "img/house.a63e61ad.svg";